var KeyedAttachmentsData = /** @class */ (function () {
    function KeyedAttachmentsData() {
        this.kattachments = [];
    }
    KeyedAttachmentsData.prototype.isFileNameDuplicate = function (value) {
        if (!this.kattachments)
            return false;
        return this.kattachments.filter(function (v) { return (v.attachment.fileNameWithExtension === value); }).length > 1;
    };
    KeyedAttachmentsData.prototype.isNameDuplicate = function (name) {
        if (!this.kattachments)
            return false;
        return this.kattachments.filter(function (v) { return (v.attachment.name === name); }).length > 1;
    };
    return KeyedAttachmentsData;
}());
export { KeyedAttachmentsData };
